
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

// constantRoutes： 代表那些不需要动态判断权限的路由，如登录页、404、等通用页面。
export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/Home'),
    hidden: true,
    meta: {
      title: '首页'
    },
    isdisplay: true
  },
  {
    path: '/downloadapp',
    component: () => import('@/views/DownloadApp/index'),
    hidden: true,
    meta: {
      title: '下载庭审app'
    },
    isdisplay: true

  },
  // {
  //   path: '/news',
  //   component: () => import('@/views/news/index'),
  //   hidden: true,
  //   meta: {
  //     title: '新闻中心'
  //   }
  // },
  // {
  //   path: '/newsbody',
  //   component: () => import('@/views/newsbody/index'),
  //   hidden: true,
  //   meta: {
  //     title: '新闻详情'
  //   }
  // },
  // {
  //   path: '/register',
  //   component: () => import('@/views/register/index'),
  //   hidden: true,
  //   meta: {
  //     title: '注册'
  //   }
  // },
  // {
  //   path: '/retrieve',
  //   component: () => import('@/views/retrieve/index'),
  //   hidden: true,
  //   meta: {
  //     title: '找回密码'
  //   }
  // },
  // {
  //   path: '/courtnotice',
  //   component: () => import('@/views/courtnotice/index'),
  //   hidden: true,
  //   meta: {
  //     title: '开庭公告'
  //   }
  // },
  // {
  //   path: '/notice',
  //   component: () => import('@/views/notice/index'),
  //   meta: {
  //     title: '公告送达'
  //   }
  // },
  // {
  //   path: '/rules',
  //   component: () => import('@/views/rules/index'),
  //   hidden: true,
  //   meta: {
  //     title: '诉讼规程'
  //   }
  // },
  // {
  //   path: '/rulessee',
  //   component: () => import('@/views/rules/see'),
  //   hidden: true,
  //   meta: {
  //     title: '诉讼规程详情'
  //   }
  // },
  // {
  //   path: '/repay',
  //   component: () => import('@/views/repay/index'),
  //   meta: {
  //     title: '还款详情'
  //   }
  // },
  // {
  //   path: '/video',
  //   component: () => import('@/views/video/index'),
  //   meta: {
  //     title: '视频调解'
  //   }
  // },
  {
    path: '/execute',
    component: () => import('@/views/execute/index'),
    hidden: true,
    meta: {
      title: '执行送达'
    },
    isdisplay: true
  },
  {
    path: '/convey',
    component: () => import('@/views/convey/index'),
    meta: {
      title: '电子传达'
    }
  },
  // {
  //   path: '/im',
  //   component: () => import('@/views/im/index'),
  //   hidden: true,
  //   meta: {
  //     title: '上传转账凭证'
  //   }
  // },
  {
    path: '/up',
    component: () => import('@/views/up/index'),
    hidden: true,
    meta: {
      title: '协议签名'
    }
  },
  {
    path: '/signature',
    component: () => import('@/views/signature/index'),
    hidden: true,
    meta: {
      title: '签字'
    }
  },
  {
    path: '/info',
    component: () => import('@/views/info/index'),
    hidden: true,
    meta: {
      title: ''
    }
  },
  {
    path: '/signanew',
    component: () => import('@/views/signan/index'),
    hidden: true,
    meta: {
      title: '签字'
    }
  },
  {
    path: '/success',
    component: () => import('@/views/success/index'),
    hidden: true,
    meta: {
      title: '人脸认证成功'
    }
  },
  {
    path: '/mediate',
    component: () => import('@/views/mediate/index'),
    hidden: true,
    meta: {
      title: '特约调解'
    }
  },
  // {
  //   path: '/mediatelist',
  //   component: () => import('@/views/mediate/list'),
  //   hidden: true,
  //   meta: {
  //     title: '案件查询'
  //   }
  // },
  // {
  //   path: '/mediatelistSee',
  //   component: () => import('@/views/mediate/see'),
  //   hidden: true,
  //   meta: {
  //     title: '案件详情'
  //   }
  // },
  {
    path: '/successnew',
    component: () => import('@/views/successnew/index'),
    hidden: true,
    meta: {
      title: '找回密码人脸认证成功'
    }
  },
  {
    path: '/failed',
    component: () => import('@/views/failed/index'),
    hidden: true,
    meta: {
      title: '人脸认证失败'
    }
  },
  {
    path: '/sign',
    component: () => import('@/views/sign/index'),
    hidden: true,
    meta: {
      title: '文书签字'
    }
  },
  // {
  //   path: '/Bcaseinformation',
  //   component: () => import('@/views/Bcaseinformation/index'),
  //   hidden: true,
  //   meta: {
  //     title: '案件信息'
  //   }
  // },
  // {
  //   path: '/defLogin',
  //   component: () => import('@/views/defLogin/index'),
  //   hidden: true,
  //   meta: {
  //     title: '被告登录'
  //   }
  // },
  // {
  //   path: '/servicehome',
  //   component: () => import('@/views/defLogin/index'),
  //   hidden: true,
  //   meta: {
  //     title: '送达平台'
  //   }
  // },
  {
    path: '/nsign',
    component: () => import('@/views/nsign/index'),
    hidden: true,
    meta: {
      title: '文书签字'
    }
  },
  {
    path: '/zj',
    component: () => import('@/views/zj/index'),
    hidden: true,
    meta: {
      title: ''
    }
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

// asyncRoutes： 代表那些需求动态判断权限并通过 addRoutes 动态添加的页面。

export const asyncRoutes = [

]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router

